export const url: string = process.env.VUE_APP_API_URL;
export const imagesUrl: string = process.env.VUE_APP_API_IMAGES;
export const password: string = process.env.VUE_APP_PASSWORD;
export const email: string = process.env.VUE_APP_EMAIL;
export const key: string = process.env.VUE_APP_SECRET_KEY;